import React from 'react'

const EmptyState = ({ message }) => (
  <div className="ResultsEmptyState">
    <p className="NoResultsText">{message}</p>
  </div>
)

export default EmptyState
